// Dependencies
require("webstrap/type");
require("grid");

// Styles
require("./introduction.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/introduction/index.js
 ** module id = 144
 ** module chunks = 0 1
 **/